/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Signin_Code_SentInputs */

const en_signin_code_sent = /** @type {(inputs: Signin_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a 6-digit code to ${i?.email}. It expires in 10 minutes.`)
};

const id_signin_code_sent = /** @type {(inputs: Signin_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kode 6 digit dikirim ke ${i?.email}. Berlaku 10 menit.`)
};

/**
* | output |
* | --- |
* | "We sent a 6-digit code to {email}. It expires in 10 minutes." |
*
* @param {Signin_Code_SentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_code_sent = /** @type {((inputs: Signin_Code_SentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Code_SentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_code_sent(inputs)
	return en_signin_code_sent(inputs)
});